import {
    AcceptIcon,
    AddIcon,
    Avatar,
    BuildingIcon,
    Button,
    ChevronStartIcon,
    Dialog,
    Divider,
    Flex,
    InfoIcon,
    Input,
    Text,
    CloseIcon,
    ArrowRightIcon,
    Dropdown,
    Alert,
    Loader,
} from "@fluentui/react-northstar";
import {
    FolderSwap20Regular,
    PersonArrowRight20Regular,
} from "@fluentui/react-icons";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, ContainerFluid } from "../../../common/styles";
import styled from "styled-components";
import { _detail_collab_table_header } from "../constant/DetailCollabPageHeader";
import EmptyDetailCollabTasks from "../constant/EmptyDetailCollabTasks";
// import { useAgency } from "..";
import moment from "moment";

import ActualStep from "../../../components/ActualStep/ActualStep";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
    _api_getOffboardingTypeStatus,
    _changeStartDateOffboardingUser,
    _changeStatusOffboardingUser,
    _getOffboardingUserDetail,
} from "../api";
import CollaboratorTasks from "../../../pages/New_Onboarding/components/CollaboratorTasks";
import MyTasks from "../../../pages/DashboardTasks/MyTasks";
import HeaderTasksList from "../../../pages/New_Onboarding/components/HeaderTasksList/HeaderTasksList";
import { DialogStyle } from "../../../pages/DashboardTasks/style";
import DialogChooseAttributionTask from "../../../pages/DashboardTasks/TasksModels/DialogChooseAttributionTask";
import DialogUseModalTask from "../../../pages/DashboardTasks/TasksModels/DialogUseModalTask";
import DialogAddIndividualTask from "../../../pages/DashboardTasks/TasksModels/DialogAddIndividualTask";
import Toast from "../../../components/Alerts";
import { ROUTES } from "../../../constants/routes";
import UserCard from "./ui/UserCard";
import { CallControlCloseTrayIcon } from "@fluentui/react-icons-northstar";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { DetailOffboardingHeader } from "./ui/DetailOffboardingHeader";
import { UserDetailContract } from "./ui/UserDetailContract";
import { CustomBadge } from "../../../components/Badge";
import { DEVICE, DEVICE_MAX } from "../../../constants/responsive";
import { useToastGlobal } from "../../../stores/useToastGlobal";
import { validateYear } from "../../../utils/dateValidation";

export default function EntryOffboardingDetailCollabPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, activeTab, AgencyId } = location.state || {};
    const userOff = location?.state?.user?.id ?? location.state.user;
    const activeTabOff = location?.state?.activeTab;
    const AgencyIdOff = location?.state?.AgencyId;
    const toast = useToastGlobal();
    const [selectedStatusId, setSelectedStatusId] = useState(null);
    const [openInfoIcon, setOpenInfoIcon] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [openAttributeTask, setOpenAttributeTask] = useState(false); // pour attribuer une tache
    const [openUseModalTask, setOpenUseModalTask] = useState(false); // pour afficher les modeles de taches
    const [openAddIndividualTask, setOpenAddIndividualTask] = useState(false); // pour afficher la modale d'une seule tâche
    const [toastConfig, setToastConfig] = useState({
        content: "",
        visible: false,
        level: "warning",
    });
    const [openChangeStatusDialog, setOpenChangeStatusDialog] = useState(false);
    const [openChangeDateDialog, setOpenChangeDateDialog] = useState(false);
    const [lenTodoTasks, setTodoTasks] = useState(null);

    const {
        data: userDetail,
        isLoading: isLoadingUserDetail,
        refetch: refetchUserOffboardingDetail,
        isFetching: isFetchingUserDetail,
    } = useQuery(
        ["_getUserDetail", user?.id ?? userOff],
        () => _getOffboardingUserDetail(user?.id ?? userOff),
        {
            onSuccess: (data) => {
                setTasks(data);
                setTodoTasks(() => {
                    // calculer juste les tâches à faire
                    return data?.tasks?.filter(
                        (task) => task.status_value === 0
                    ).length;
                });
            },
        }
    );

    const { data: typeStatusData } = useQuery(
        ["_getOffboardingTypeStatus", user?.id ?? userOff],
        () => _api_getOffboardingTypeStatus(user?.id ?? userOff),
        {
            refetchOnWindowFocus: false,
        }
    );

    const { mutate: mutateChangeStatus, isLoading: isLoadingChangeStatus } =
        useMutation("changeStatusOffboardingUser::PATCH", (data) => {
            return _changeStatusOffboardingUser(data);
        });

    const ListStatus = [
        {
            id: 1,
            name: "Préparer le départ",
            status_name: "waiting_offboarding",
        },
        {
            id: 2,
            name: "Offboarding",
            status_name: "offboarding",
        },
        {
            id: 3,
            name: "Archivé",
            status_name: "archived",
        },
    ];

    const userChooseType = (type) => {
        setOpenAttributeTask(false);
        switch (type) {
            case "USE_MODAL":
                setOpenUseModalTask(true);
                break;
            case "CREATE_TASK_FROM_ZERO":
                setOpenAddIndividualTask(true);
                break;
        }
    };

    const {
        mutate: mutateChangeStartDate,
        isLoading: isLoadingChangeStartDate,
    } = useMutation("changeStartDateOffboardingUser::PATCH", (data) => {
        return _changeStartDateOffboardingUser(data);
    });

    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
        reset,
    } = useForm();

    const onSubmit = (data) => {
        // mutate change data
        if (data) {
            setOpenChangeDateDialog(false);
            mutateChangeStartDate(
                { data: data, id_user: user?.id },
                {
                    onSuccess: (res) => {
                        if (res.success) {
                            toast.setShow({
                                content:
                                    "La date de départ a bien été changée ",
                                level: "success",
                                visible: true,
                                dismissible: true,
                            });

                            reset();
                            return navigate(location.pathname, {
                                state: {
                                    ...location.state,
                                    user: {
                                        ...user,
                                        departure_date: data.startDate,
                                    },
                                },
                            });
                        } else {
                            toast.setShow({
                                visible: true,
                                content:
                                    "Erreur lors de la modification de la date de départ",
                                level: "danger",
                                dismissible: true,
                            });
                        }
                    },
                }
            );
        } else {
            setOpenChangeDateDialog(true);
            console.log("ERROOR :Date  non sélectionnée");
        }
    };

    const methodsChangeStatus = useForm({
        defaultValues: {
            status: user?.offboarding_status?.status_text,
            startDate: user?.departure_date,
        },
    });

    const submitChangeStatus = (data) => {
        // mutate change data
        const findType = typeStatusData?.find(
            (el) => el?.value === data?.status
        );
        const startDate = data?.startDate;
        const id_type = findType?.id;
        const id_user = user?.id;
        const payload = { id_type, startDate, id_user };
        const isToday = moment().isSame(startDate, "day");
        // console.log({ muyate: data, typeStatusData, isToday, startDate });
        const archived = data?.status === "Archivé";
        const StartDateFormated = moment(startDate).format("DD/MM/YYYY");
        mutateChangeStatus(payload, {
            onSuccess: (res) => {
                if (res.success) {
                    toast.setShow({
                        visible: true,
                        content:
                            isToday && archived
                                ? " Ce collaborateur a bien été archivé "
                                : archived && !isToday
                                ? ` L'archivage de ce collaborteur est programmé et sera effectuée le ${StartDateFormated} `
                                : "Statut modifié avec succès",
                        level: "success",
                        dismissible: true,
                    });
                    refetchUserOffboardingDetail();
                    setOpenChangeStatusDialog(false);
                    setTimeout(() => {
                        navigate(
                            `/offboarding?tab=${AgencyId}&subtab=${activeTab}`
                        );
                    }, 2000);
                    return;
                } else {
                    toast.setShow({
                        visible: true,
                        content: "Erreur lors de la modification du statut",
                        level: "danger",
                        dismissible: true,
                    });
                }
            },
        });
    };

    const typeStatusDataFormated = typeStatusData?.map((el) => {
        return (
            {
                id: el.id,
                content: el.value,
            } ?? []
        );
    });

    const typeStatusDataForInterrompreOffboarding = [
        {
            id: 1,
            content: "Suivi",
        },
        {
            id: 5,
            content: "Archivé",
        },
    ];

    const getStatusMessage = (id) => {
        switch (id) {
            case -3:
                return (
                    <Flex column gap="gap.smaller">
                        <Flex vAlign="center" gap="gap.small">
                            <InfoIcon outline />
                            <Text content="Ce statut a pour conséquences sur le collaborateur :" />
                        </Flex>
                        <Flex styles={{ marginLeft: "46px" }}>
                            <ul>
                                <li>
                                    <Text content="Il aura accès à l'ensemble de l'outil et sera inclus dans l'organigramme" />
                                </li>
                            </ul>
                        </Flex>
                    </Flex>
                );
            case 6:
                return (
                    <Flex column gap="gap.smaller">
                        <Flex vAlign="center" gap="gap.small">
                            <InfoIcon outline />
                            <Text content="Ce statut a pour conséquences sur le collaborateur :" />
                        </Flex>
                        <Flex styles={{ marginLeft: "46px" }}>
                            <ul>
                                <li>
                                    <Text content="Il aura accès à l'ensemble de l'outil et sera inclus dans l'organigramme" />
                                </li>
                            </ul>
                        </Flex>
                    </Flex>
                );
            case 5:
                return (
                    <Flex column gap="gap.smaller">
                        <Flex vAlign="center" gap="gap.small">
                            <InfoIcon outline />
                            <Text content="Le changement de statut aura des conséquences sur le collaborateur :" />
                        </Flex>
                        <Flex styles={{ marginLeft: "46px" }}>
                            <ul>
                                <li>
                                    <Text content="Plus de connexion possible à Yeetch." />
                                </li>
                                <li>
                                    <Text content="Archivage de la liste de tâches" />
                                </li>
                                <li>
                                    <Text content="Réinitialisation de tous les soldes (vacances, récupération, congés payés...)" />
                                </li>
                                <li>
                                    <Text content="Il ne sera plus visible dans l'outil" />
                                </li>
                            </ul>
                        </Flex>
                    </Flex>
                );
            case 1:
                return (
                    <Flex column gap="gap.smaller">
                        <Flex vAlign="center" gap="gap.small">
                            <InfoIcon outline />
                            <Text content="Ce statut a pour conséquences sur le collaborateur :" />
                        </Flex>
                        <Flex styles={{ marginLeft: "46px" }}>
                            <ul>
                                <li>
                                    <Text content="Il aura accès à l’ensemble de l’outil et sera inclus dans l’organigramme" />
                                </li>
                            </ul>
                        </Flex>
                    </Flex>
                );
            default:
                return "";
        }
    };

    const today = new Date().toISOString().split("T")[0];

    if (isLoadingUserDetail)
        return (
            <Flex
                styles={{ width: "100%", height: "100dvh" }}
                fill
                hAlign="center"
                vAlign="center"
            >
                <Loader label="Chargement des données..." />
            </Flex>
        );

    return (
        <ContainerFluid styles={{ background: "#f5f5f5" }}>
            <Container gap="gap.medium" column>
                <Toast
                    visible={toastConfig?.visible}
                    content={toastConfig?.content}
                    level={toastConfig?.level}
                    onStatusChange={() => {
                        return setToastConfig({
                            visible: false,
                            content: "",
                            level: "warning",
                        });
                    }}
                />
                {/* Header */}
                <DetailOffboardingHeader
                    activeTab={activeTab ?? activeTabOff}
                    AgencyId={AgencyId ?? AgencyIdOff}
                />
                <MainContent fill column>
                    <Flex space="between">
                        <UserCard user={user ?? userOff} />

                        <Flex vAlign="center">
                            {/* STEPPER HERE  */}
                            <ActualStep
                                ListStatus={ListStatus}
                                status={
                                    user?.offboarding_status?.status ??
                                    userOff?.offboarding_status?.status
                                }
                            />
                            {/* STEPPER HERE  */}
                        </Flex>
                        <Flex
                            styles={{
                                width: "225px",
                            }}
                            vAlign="center"
                            hAlign="end"
                            gap="gap.smaller"
                            column
                        >
                            {user?.departure_date && (
                                <>
                                    <Flex vAlign="center" gap="gap.smaller">
                                        <LabelDepartDate content="Date de départ" />
                                        <Dialog
                                            onCancel={() =>
                                                setOpenInfoIcon(false)
                                            }
                                            open={openInfoIcon}
                                            styles={{ width: "443px" }}
                                            header="Informations de départ"
                                            headerAction={{
                                                icon: <CloseIcon />,
                                                title: "Close",
                                                onClick: () =>
                                                    setOpenInfoIcon(false),
                                            }}
                                            content={
                                                <UserDetailContract
                                                    user={user}
                                                />
                                            }
                                            trigger={
                                                <InfoIcon
                                                    outline
                                                    onClick={() =>
                                                        setOpenInfoIcon(true)
                                                    }
                                                />
                                            }
                                        />
                                    </Flex>
                                    <DepartDate
                                        content={moment(
                                            user.departure_date
                                        ).format("DD/MM/YYYY")}
                                    />
                                </>
                            )}
                        </Flex>
                    </Flex>

                    <Flex
                        styles={{
                            // height: "80%",
                            // paddingBlock: "32px",
                            minHeight: "500px",
                            maxHeight: "500px",
                            overflowY: "auto",
                        }}
                    >
                        {/* Empty detail collab tasks  */}

                        {/* <EmptyDetailCollabTasks activeTab={activeTab} /> */}

                        <Flex fill column>
                            <Toast
                                visible={toastConfig?.visible}
                                content={toastConfig?.content}
                                level={toastConfig?.level}
                                onStatusChange={() => {
                                    return setToastConfig({
                                        visible: false,
                                        content: "",
                                        level: "warning",
                                    });
                                }}
                            />

                            {/* UTILISER UN MODELE DE TACHE */}
                            <DialogUseModalTask
                                setShowAlert={() => {
                                    return setToastConfig({
                                        visible: true,
                                        content: "Tâches bien ajoutées",
                                        level: "success",
                                    });
                                }}
                                open={openUseModalTask}
                                setOpen={setOpenUseModalTask}
                            />
                            {/* UTILISER UNE MODAL INDIVIDUAL TASK */}
                            <DialogAddIndividualTask
                                setShowAlert={() => {
                                    return setToastConfig({
                                        visible: true,
                                        content: "Tâche bien ajoutée",
                                        level: "success",
                                    });
                                }}
                                open={openAddIndividualTask}
                                setOpen={setOpenAddIndividualTask}
                            />
                            <Flex gap="gap.medium" vAlign="center">
                                {/* header counter */}
                                <HeaderTasksList count={lenTodoTasks} />
                                {/* divider */}
                                {activeTab !== 0 && (
                                    <Flex
                                        styles={{
                                            height: "55px ",
                                        }}
                                    >
                                        <Divider size={1} vertical />
                                    </Flex>
                                )}
                                {/* ADD TASK */}
                                {activeTab !== 0 && (
                                    <DialogStyle
                                        header="Attribuer une tâche"
                                        open={openAttributeTask}
                                        onCancel={() =>
                                            setOpenAttributeTask(false)
                                        }
                                        content={
                                            <DialogChooseAttributionTask
                                                cb={userChooseType}
                                            />
                                        }
                                        trigger={
                                            <Button
                                                icon={<AddIcon />}
                                                text
                                                primary
                                                content="Ajouter une tâche"
                                                onClick={() =>
                                                    setOpenAttributeTask(true)
                                                }
                                            />
                                        }
                                    />
                                )}
                            </Flex>
                            {userDetail?.tasks?.length === 0 ? (
                                <EmptyDetailCollabTasks activeTab={activeTab} />
                            ) : (
                                <TaskFlex>
                                    <MyTasks
                                        user={user ?? userOff}
                                        activeTab={activeTab}
                                        AgencyId={AgencyId}
                                        tasks={userDetail?.tasks}
                                        isFetchingUserDetail={
                                            isFetchingUserDetail ||
                                            isLoadingUserDetail
                                        }
                                        // isPageOnboarding={true}
                                        isPageOnboarding={false}
                                        isPageOffboarding={true}
                                    />
                                </TaskFlex>
                            )}
                        </Flex>
                    </Flex>
                </MainContent>
                <FooterAction hAlign="end" gap="gap.small">
                    {/* changer la date actions when ACTIVE_TAB === 1 */}
                    {/* changer la date actions when ACTIVE_TAB === 1 */}
                    {/* changer la date actions when ACTIVE_TAB === 1 */}

                    {activeTab === 1 && (
                        <Dialog
                            open={openChangeDateDialog}
                            confirmButton={{
                                content: "Changer la date de départ",
                                loading: isLoadingChangeStartDate,
                                flat: true,
                            }}
                            onConfirm={handleSubmit(onSubmit)}
                            onCancel={() => {
                                setOpenChangeDateDialog(false);
                                return reset();
                            }}
                            cancelButton={{ content: "Annuler", flat: true }}
                            header="Changer la date de départ"
                            content={
                                <Flex fill column>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Flex fill column>
                                            <Text content=" À quelle date voulez-vous mettre la date de départ ? *" />
                                            <Input
                                                fluid
                                                type="date"
                                                min={today}
                                                defaultValue={
                                                    user.departure_date || today
                                                }
                                                error={!!errors.startDate}
                                                {...register("startDate", {
                                                    required:
                                                        "Ce champ est obligatoire",
                                                    validate: validateYear,
                                                })}
                                            />
                                        </Flex>
                                        {errors.startDate && (
                                            <Text
                                                color="red"
                                                content={
                                                    errors.startDate.message
                                                }
                                            />
                                        )}
                                    </form>
                                </Flex>
                            }
                            headerAction={{
                                icon: <CallControlCloseTrayIcon />,
                                title: "Close",
                                onClick: () => setOpenChangeDateDialog(false),
                            }}
                            trigger={
                                <Button
                                    onClick={() =>
                                        setOpenChangeDateDialog(true)
                                    }
                                    iconPosition="after"
                                    icon={<FolderSwap20Regular />}
                                    flat
                                    content="Changer la date de départ"
                                />
                            }
                        />
                    )}

                    {/* changer la date actions when ACTIVE_TAB === 1 */}
                    {/* changer la date actions when ACTIVE_TAB === 1 */}
                    {/* changer la date actions when ACTIVE_TAB === 1 */}

                    {/* changer le STATUT when ACTIVE_TAB ==0  */}
                    {/* changer le STATUT when ACTIVE_TAB ==0  */}
                    {/* changer le STATUT when ACTIVE_TAB ==0  */}

                    {activeTab === 0 && (
                        <Dialog
                            open={openChangeStatusDialog}
                            confirmButton={{
                                content: "Changer le statut",
                                onClick: handleSubmit(submitChangeStatus),
                                disabled: !isValid,
                                loading: isLoadingChangeStatus,
                                flat: true,
                            }}
                            cancelButton={{ content: "Annuler", flat: true }}
                            onCancel={() => {
                                setOpenChangeStatusDialog(false);
                                reset();
                                setSelectedStatusId(null);
                            }}
                            header="Changer le statut"
                            headerAction={{
                                icon: <CloseIcon />,
                                title: "Close",
                                onClick: () => {
                                    setOpenChangeStatusDialog(false), reset();
                                },
                            }}
                            content={
                                <FormProvider {...methodsChangeStatus}>
                                    <form
                                        onSubmit={handleSubmit(
                                            submitChangeStatus
                                        )}
                                    >
                                        <Flex gap="gap.small" column fill>
                                            <Flex
                                                gap="gap.small"
                                                // space="between"
                                                vAlign="center"
                                                fill
                                            >
                                                <CustomBadge
                                                    bg="#E8EBFA"
                                                    color="#4F52B2"
                                                    label={
                                                        <b>
                                                            {
                                                                user?.current_status
                                                            }
                                                        </b>
                                                    }
                                                    rectangular
                                                    styles={{
                                                        width: "106px",
                                                        justifyContent:
                                                            "center",
                                                    }}
                                                />
                                                <ArrowRightIcon />

                                                <Controller
                                                    name="status"
                                                    control={control}
                                                    render={({
                                                        field: {
                                                            onChange,
                                                            value,
                                                            name,
                                                            ref,
                                                            onBlur,
                                                        },
                                                    }) => (
                                                        <Dropdown
                                                            fill
                                                            items={
                                                                typeStatusDataFormated
                                                            }
                                                            onBlur={onBlur}
                                                            value={value}
                                                            placeholder="Choisir un statut dans la liste"
                                                            checkable={true}
                                                            getA11ySelectionMessage={{
                                                                onAdd: (item) =>
                                                                    `${item} has been selected.`,
                                                            }}
                                                            onChange={(
                                                                _,
                                                                i
                                                            ) => {
                                                                {
                                                                    onChange(
                                                                        i.value
                                                                            .content
                                                                    ),
                                                                        setSelectedStatusId(
                                                                            i
                                                                                .value
                                                                                .id
                                                                        );
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Flex>
                                            <Flex column>
                                                <Text content="A partir de" />
                                                <Input
                                                    type="date"
                                                    min={today}
                                                    defaultValue={today}
                                                    error={!!errors.startDate}
                                                    {...register("startDate", {
                                                        required:
                                                            "Ce champ est obligatoire",
                                                        validate: (value) => {
                                                            if (value < today) {
                                                                return "La date ne peut pas être antérieure à aujourd'hui.";
                                                            }
                                                            return true;
                                                        },
                                                    })}
                                                />
                                            </Flex>
                                            {selectedStatusId && (
                                                <StatusTextToDisplay>
                                                    <Text
                                                        content={getStatusMessage(
                                                            selectedStatusId
                                                        )}
                                                    />
                                                </StatusTextToDisplay>
                                            )}
                                        </Flex>
                                    </form>
                                </FormProvider>
                            }
                            trigger={
                                <Button
                                    onClick={() =>
                                        setOpenChangeStatusDialog(true)
                                    }
                                    content=" Changer le statut "
                                />
                            }
                        />
                    )}
                    {/* changer le STATUT when ACTIVE_TAB ==0  */}
                    {/* changer le STATUT when ACTIVE_TAB ==0  */}
                    {/* changer le STATUT when ACTIVE_TAB ==0  */}
                    {activeTab === 0 && (
                        <Button
                            onClick={() => {
                                return navigate(
                                    `${ROUTES.offboarding.prepare_offboarding}${location.search}`,
                                    {
                                        state: {
                                            id: user.id,
                                            key: user.id,
                                            content: user?.job_title,
                                            email: user.username,
                                            header: user.name,
                                            image: user.avatar,
                                        },
                                    }
                                );
                            }}
                            iconPosition="after"
                            icon={<PersonArrowRight20Regular />}
                            flat
                            primary
                            content={"Lancer l'offboarding"}
                        />
                    )}

                    {/* interrompre l'offboarding  */}

                    {activeTab === 1 && (
                        <Dialog
                            open={openChangeStatusDialog}
                            confirmButton={{
                                content: "Valider le statut",
                                onClick: handleSubmit(submitChangeStatus),
                                loading: isLoadingChangeStatus,
                                primary: true,
                                flat: true,
                            }}
                            cancelButton={{ content: "Annuler", flat: true }}
                            onCancel={() => {
                                setOpenChangeStatusDialog(false);
                                reset();
                                setSelectedStatusId(null);
                            }}
                            header="Interrompre l'offboarding ?"
                            headerAction={{
                                icon: <CloseIcon />,
                                title: "Close",
                                onClick: () => {
                                    setOpenChangeStatusDialog(false), reset();
                                },
                            }}
                            content={
                                <FormProvider {...methodsChangeStatus}>
                                    <form
                                        onSubmit={handleSubmit(
                                            submitChangeStatus
                                        )}
                                    >
                                        <Flex gap="gap.small" column fill>
                                            <Flex
                                                gap="gap.small"
                                                // space="between"
                                                vAlign="center"
                                                fill
                                            >
                                                <CustomBadge
                                                    bg="#E8EBFA"
                                                    color="#4F52B2"
                                                    label={
                                                        <b>
                                                            {
                                                                user
                                                                    ?.offboarding_status
                                                                    .status_text
                                                            }
                                                        </b>
                                                    }
                                                    rectangular
                                                    styles={{
                                                        width: "106px",
                                                        justifyContent:
                                                            "center",
                                                    }}
                                                />
                                                <ArrowRightIcon />

                                                <Controller
                                                    name="status"
                                                    control={control}
                                                    render={({
                                                        field: {
                                                            onChange,
                                                            value,
                                                            name,
                                                            ref,
                                                            onBlur,
                                                        },
                                                    }) => (
                                                        <Dropdown
                                                            fill
                                                            items={
                                                                typeStatusDataForInterrompreOffboarding
                                                            }
                                                            onBlur={onBlur}
                                                            value={value}
                                                            placeholder="Choisir un statut dans la liste"
                                                            checkable={true}
                                                            getA11ySelectionMessage={{
                                                                onAdd: (item) =>
                                                                    `${item} has been selected.`,
                                                            }}
                                                            onChange={(
                                                                _,
                                                                i
                                                            ) => {
                                                                {
                                                                    onChange(
                                                                        i.value
                                                                            .content
                                                                    ),
                                                                        setSelectedStatusId(
                                                                            i
                                                                                .value
                                                                                .id
                                                                        );
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Flex>
                                            <Flex column>
                                                <Text content="A partir de" />
                                                <Input
                                                    type="date"
                                                    min={today}
                                                    defaultValue={today}
                                                    error={!!errors.startDate}
                                                    {...register("startDate", {
                                                        required:
                                                            "Ce champ est obligatoire",
                                                        validate: (value) => {
                                                            if (value < today) {
                                                                return "La date ne peut pas être antérieure à aujourd'hui.";
                                                            }
                                                            return true;
                                                        },
                                                    })}
                                                />
                                            </Flex>
                                            {selectedStatusId && (
                                                <StatusTextToDisplay>
                                                    <Text
                                                        content={getStatusMessage(
                                                            selectedStatusId
                                                        )}
                                                    />
                                                </StatusTextToDisplay>
                                            )}
                                        </Flex>
                                    </form>
                                </FormProvider>
                            }
                            trigger={
                                <Button
                                    onClick={() =>
                                        setOpenChangeStatusDialog(true)
                                    }
                                    content=" Interrompre l'offboarding "
                                    primary
                                />
                            }
                        />
                    )}
                </FooterAction>
            </Container>
        </ContainerFluid>
    );
}

const TaskFlex = styled(Flex)`
    overflow-y: scroll;

    @media ${DEVICE.tablet} {
        height: 250px;
    }
    @media ${DEVICE.laptop} {
        height: 450px;
    }
    @media ${DEVICE.laptopL} {
        height: 740px;
    }
    @media ${DEVICE.desktop} {
        height: 500px;
    }
    @media ${DEVICE.desktopL} {
        height: 500px;
    }
`;
const MainContent = styled(Flex)`
    padding: 16px 24px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
    gap: 24px;

    @media ${DEVICE.tablet} {
        height: 250px;
    }
    @media ${DEVICE.laptop} {
        height: 650px;
    }
    @media ${DEVICE.laptopL} {
        height: 700px;
    }
    @media ${DEVICE.desktop} {
        height: 500px;
    }
    @media ${DEVICE.desktopL} {
        height: 500px;
    }
`;

const StatusTextToDisplay = styled(Flex)`
    border-radius: 4px;
    border: 1px solid #d1d1d1;
    background: #e0e0e0;
    padding: 8px 16px;
`;

const FooterAction = styled(Flex)`
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 24px;
    max-width: 1440px;
    margin: 0 auto;
    border-bottom: 1px solid #d1d1d1;
    background: #fff;
    box-shadow: 0px -1.2px 3.6px 0px rgba(0, 0, 0, 0.11),
        0px -6.4px 14.4px 0px rgba(0, 0, 0, 0.13);
`;

const DepartDate = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const LabelDepartDate = styled(Text)`
    color: #424242;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;
